import { endOfDay, getUnixTime, startOfDay } from 'date-fns'

/** `to` is absent while only the first day is picked (treated as a single day). */
export interface DateRangeValue {
  from: Date
  to?: Date
}

interface DateRangeTimestamps {
  timestampGte?: number
  timestampLte?: number
}

/**
 * Snap a day range to the inclusive unix-second bounds the BFF expects
 * (`timestamp_gte` / `timestamp_lte`): start-of-day `from` to end-of-day `to`.
 */
export const dateRangeToTimestamps = (range: DateRangeValue | undefined): DateRangeTimestamps => {
  if (!range?.from) return {}

  const end = range.to ?? range.from

  return {
    timestampGte: getUnixTime(startOfDay(range.from)),
    timestampLte: getUnixTime(endOfDay(end))
  }
}
